import {
  type SidePanelStoreProps,
  useSidePanelStore,
} from '../store/side-panel.store';

export const useSidePanel = () => {
  const sidePanelStore = useSidePanelStore();

  return {
    props: sidePanelStore.sidePanelState.props,
    events: sidePanelStore.sidePanelState.events,
    config: sidePanelStore.sidePanelState.config,
    labels: sidePanelStore.sidePanelState.labels,
    openSidePanel: (payload: SidePanelStoreProps) => {
      sidePanelStore.openSidePanel(payload);
    },
    closeSidePanel: () => {
      sidePanelStore.closeSidePanel();
    },
  };
};
